import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import Nav from '../components/Header/Nav';

const Main = () => {
    return (
        <div>
            <Nav />
            <Outlet/>
            <Footer />
        </div>
    );
};

export default Main;